module.exports = __webpack_public_path__ + "static/media/unnnn.27beac01.png";